// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--1lLx5","link":"_93444fe79c--link--1tnLc","title":"_93444fe79c--title--2x-ij","dot":"_93444fe79c--dot--2Cxps"};